export enum Alignment {
  ALIGNED = "Aligned",
  NOT_ALIGNED = "Not aligned",
}
